var React = require('react');

function Padlock (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#00008f;}")),React.createElement("title",{"key":1},"padlock"),React.createElement("path",{"className":"cls-1","d":"M76,39.35H73.89V30.28a25.3,25.3,0,0,0-50.59,0v9.07H20a5,5,0,0,0-5,5V79a5,5,0,0,0,5,5H76a5,5,0,0,0,5-5V44.35A5,5,0,0,0,76,39.35ZM25.3,30.28a23.3,23.3,0,0,1,46.59,0v9.07H66.78V30.28a18.19,18.19,0,0,0-36.37,0v9.07H25.3Zm7.11,9.07V30.28a16.19,16.19,0,0,1,32.37,0v9.07ZM20,41.35H76a3,3,0,0,1,3,3V74.89H17V44.35A3,3,0,0,1,20,41.35ZM76,82H20a3,3,0,0,1-3-3V76.89H79V79A3,3,0,0,1,76,82Z","key":2}),React.createElement("path",{"className":"cls-1","d":"M47,57.82v7.41a1,1,0,0,0,2,0V57.82a4.56,4.56,0,1,0-2,0Zm1-7a2.55,2.55,0,1,1-2.56,2.55A2.56,2.56,0,0,1,48,50.83Z","key":3})]);
}

Padlock.defaultProps = {"id":"svg_2px","data-name":"svg 2px","viewBox":"0 0 96 96"};

module.exports = Padlock;

Padlock.default = Padlock;
